<template>
  <div class="w-full flex flex-col items-center justify-center text-xs md:text-sm py-6 bg-white">
    <a 
      :href="websiteUrlWithTracking" 
      target="_blank" 
      rel="noopener"
      class="powered-by-link flex flex-col items-center text-black font-medium mb-3"
    >
      <span class="mb-2">Powered by</span>
      <img src="/imagotipo-black.svg" alt="GrapePerks" class="h-5 md:h-6" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'PoweredByFooter',
  props: {
    pageType: {
      type: String,
      required: true,
      validator: (val) => ['waiting-list', 'review'].includes(val),
    },
  },
  computed: {
    websiteUrlWithTracking() {
      const baseUrl = this.$enums.AppLinks.WEBSITE;
      const params = new URLSearchParams({
        source: this.pageType === 'waiting-list' ? 'waiting-list' : 'review',
        element: 'powered-by-footer',
      });
      
      return `${baseUrl}?${params.toString()}`;
    },
  },
};
</script>

<style scoped>
.powered-by-link {
  opacity: 0.7;
  transition: opacity 250ms ease-out;
}

.powered-by-link:hover {
  opacity: 1;
}
</style>
